import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../Styles/Redirecting Styles/FooterStyle/AboutCompany.css";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/scss/modal-video.scss";
import { Link } from "react-router-dom";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import pdf1 from "../../../assets/company-pdf/Company-Profile.pdf";
import axios from "axios";
import CanadaFooter from "../../Components/Footer";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import { Helmet } from "react-helmet";
import AboutImg from "../../../assets/All Images/new-york-city-manhattan-skyline-aerial-view-dusk(1).jpg";
import Img1 from "../../../assets/julius-team-profil.avif";
import Img2 from "../../../assets/yesha-team-profile.avif";
import Img3 from "../../../assets/Rejo-sir.png";

const CanadaAboutUs = () => {
  var setting1 = {
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [isOpen, setOpen] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [isLoading, setLoading] = useState(false);

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);

    try {
      const response = await axios({
        method: "post",
        url: "https://mars.zithas.com/api/portfolio",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        axios({
          url: "https://mars.zithas.com/api/getpdf", //your url
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          alert("Plaese click ok button to Download Company Portfolio");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "company-porfolio.pdf");
          document.body.appendChild(link);
          link.click();
        });
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [team, setTeam] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        // const { data } = await axios.get("https://mars.zithas.com/api/team");
        const { data } = await axios.get(
          "https://napi.zithas.com/api/pillars/getByCountry/3", // 3 = usa
        );
        if (data.success) {
          setTeam(
            data?.data
              ?.filter((item) => item.status === 1)
              ?.map((item) => ({
                id: item.id,
                name: item.staff_name,
                designation: item.designation,
                link: item.image,
              }))
              ?.reverse(),
          );
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, []);

  return (
    <div>
      <Helmet>
        <title>About Us | Zithas Technologies USA</title>
        <meta
          name="description"
          content="Zithas Technologies- Leading the way in innovative IT solutions. Your trusted partner for cutting-edge web solutions and exceptional service in USA."
        />
      </Helmet>
      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg_about pt-175 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
                  About Us
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Our extensive network of industry experts seamlessly
                      blends a global perspective into our distinct
                      organizational culture, catalyzing business growth and
                      success.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Section */}
      <section className="bd-about-area-two second-part-resp pt-80 pb-100 ">
        <div
          className="container about-second-resp  "
          style={{ maxWidth: "1250px" }}
        >
          <div className="row justify-content-center d-flex align-items-center">
            <div className="col-xl-6 col-lg-8 responsive-section1 ">
              <div className="bd-about-text-two bd-about-text-five ">
                <div className="bd-section-title-wrapper mb-25">
                  <h2 className="bd-section-title mb-15">
                    Get to know Zithas!
                  </h2>
                  <p
                    className="about-us para-about"
                    style={{ fontSize: "18px" }}
                  >
                    Zithas Technologies offers cutting-edge IT solutions that
                    empower your business to thrive in the market. Since 2020,
                    we've been delivering our services in USA, bolstering
                    enterprises to flourish. Our team comprises skilled
                    professionals with diverse expertise, dedicated to
                    delivering optimal solutions for your business challenges.
                    With over 15 years of experience, we've served clients
                    globally across various industries, continually enhancing
                    our services to better meet our customers' needs.
                  </p>
                  <h6
                    className="bd-section-title mb-15"
                    style={{ fontSize: "20px", lineHeight: "1.45" }}
                  >
                    Your business stands to gain a distinct advantage when you
                    choose to collaborate with us.
                  </h6>
                  <p
                    className="about-us para-about"
                    style={{ fontSize: "18px" }}
                  >
                    Our mission extends beyond delivering exceptional services
                    to our clients. We are dedicated to offering them a
                    transformative experience that fuels business growth,
                    propelling them to new heights of success.
                  </p>
                  <p
                    className="about-us para-about"
                    style={{ fontSize: "18px" }}
                  >
                    Through our highly effective strategies and proactive
                    approach, our aim is to maximize the market presence of your
                    business, expand its reach, enhance visibility, elevate
                    recognition, and improve overall quality.
                  </p>
                  <div className="bd-about-text-five-facts">
                    <ul>
                      <li>
                        <div
                          className="bd-about-text-five-fact"
                          data-animation="fadeInUp"
                          data-delay="1.1s"
                        >
                          <h4 className="bd-slider-fact-title text-heading">
                            150+
                          </h4>
                          <span className="bd-slider-fact-subtitle">
                            Happy Clients
                          </span>
                        </div>
                      </li>
                      <li>
                        <div
                          className="bd-about-text-five-fact"
                          data-animation="fadeInUp"
                          data-delay="1.3s"
                        >
                          <h4 className="bd-slider-fact-title text-heading">
                            200+
                          </h4>
                          <span className="bd-slider-fact-subtitle">
                            Project Cmpleted
                          </span>
                        </div>
                      </li>
                      <li>
                        <div
                          className="bd-about-text-five-fact"
                          data-animation="fadeInUp"
                          data-delay="1.5s"
                        >
                          <h4 className="bd-slider-fact-title text-heading">
                            300+
                          </h4>
                          <span className="bd-slider-fact-subtitle">
                            Team Members
                          </span>
                        </div>
                      </li>
                      <li>
                        <div
                          className="bd-about-text-five-fact"
                          data-animation="fadeInUp"
                          data-delay="1.5s"
                        >
                          <h4 className="bd-slider-fact-title text-heading">
                            $50K
                          </h4>
                          <span className="bd-slider-fact-subtitle">
                            Highest Project Value
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-8  second-part responsive-section2">
              <img
                src={
                  "https://img.freepik.com/free-photo/new-york-city-manhattan-skyline-aerial-view-dusk_649448-1766.jpg"
                }
                alt="New York City skyline at dusk"
                className="w-100"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}

      <section
        className="bd-video-area pt-60 pb-50"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section_about">
              <div className="bd-video-text">
                <p className="contact_section second-para-resp">
                  Connect Inspiration to{" "}
                  <span style={{ color: "#ffbf1e" }}>Excellence</span>
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section_about">
              <div className="contact-stuff_about pt-05">
                <div className="contact_icon_about icon_respon mr-30">
                  <div className="bd-about-text-btn ">
                    <a
                      href={pdf1}
                      download
                      className="theme-btn mr-15 three-button-respon"
                      style={{
                        paddingRight: "25px",
                        paddingLeft: "25px",
                        backgroundColor: "rgb(255, 191, 30)",
                      }}
                    >
                      <i
                        style={{
                          lineHeight: "4",
                          fontStyle: "normal",
                          color: "black",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faDownload}
                          style={{ fontSize: "20px", paddingRight: "10px" }}
                        />
                        Company Profile
                      </i>
                    </a>
                  </div>
                </div>
                <div className="contact_icon_about icon_respon_about">
                  <div className="bd-about-text-btn">
                    <button
                      className="theme-btn mr-15 "
                      data-bs-toggle="modal"
                      data-bs-target="#portfolioModal2"
                      style={{
                        paddingRight: "25px",
                        paddingLeft: "25px",
                        backgroundColor: "rgb(255, 191, 30)",
                      }}
                    >
                      <i
                        style={{
                          lineHeight: "4",
                          fontStyle: "normal",
                          color: "black",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faDownload}
                          style={{ fontSize: "20px", paddingRight: "10px" }}
                        />
                        Our Porfolio
                      </i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* modal popup */}
          <div
            className="modal fade"
            id="portfolioModal2"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content" style={{ width: "120%" }}>
                <div className="modal-header" style={{ border: "none" }}>
                  <h5 className="modal-title" id="exampleModalLabel">
                    Fill out the Details!
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    style={{ marginLeft: "50px" }}
                  ></button>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "100%", paddingRight: "25px" }}>
                    {/* {isLoading ? (<Spinner/>) : ()} */}
                    <form onSubmit={onHandleSubmit}>
                      <div className="row" style={{ paddingTop: "23px" }}>
                        <div className="bd-contact-field mb-20">
                          <input
                            className="blog-form"
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            style={{}}
                            placeholder="Name"
                            name="user_name"
                            required
                          />
                        </div>
                        <div className="bd-contact-field mb-20">
                          <input
                            type="email"
                            placeholder="Email"
                            onChange={(e) => setEmail(e.target.value)}
                            name="user_email"
                            style={{}}
                            required
                          />
                        </div>
                        <div className="bd-contact-field mb-20 ">
                          <input
                            type="text"
                            placeholder="Contact No"
                            onChange={(e) => setMobile(e.target.value)}
                            name="user_contact"
                            style={{}}
                            required
                          />
                        </div>
                        <div className="col-12 mb-20">
                          <div className="bd-contact-field">
                            <button type="submit" className="theme-btn">
                              Download
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="hello">
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659453801/website/home/portfolio-side_y0lpqc.jpg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third section */}
      <section className="bd-choose-area fix pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="bd-choose-shape pb-100">
            <div className="row">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 third-section1-resp">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-img z-index mt-70">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/icons/Reach-business-goal_y0od31.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2 className="bd-choose-info-title mb-15">
                                Reach Business Goal
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441373/website/icons/Vision-into-reality_rfx1um.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2 className="bd-choose-info-title mb-15">
                                Vison into Reality
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row ml-15">
                      <div className="col mr-30">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/icons/Market-awareness_jvyjqm.png" />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2 className="bd-choose-info-title mb-15">
                              Market Awareness
                            </h2>
                          </div>
                        </div>
                      </div>
                      <div className="col">
                        <div className="animate-hover">
                          <div className="bd-choose-info-icon mb-15">
                            <i>
                              <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/icons/Highest-Potentials_qrlxpj.png" />
                            </i>
                          </div>
                          <div className="bd-choose-info-text">
                            <h2 className="bd-choose-info-title mb-15">
                              Highest Potentials
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 third-section2-resp">
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title third-section-tittle">
                    Our Vision inspires us!
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p className="third-para">
                      Zithas aspires to become the leading IT service provider,
                      backed by a dedicated team of professionals. Our enduring
                      vision includes expanding our service offerings in USA and
                      remaining at the forefront of technology, empowering your
                      business to realize its full potential.
                    </p>
                    <h4 className=" third-para ">
                      Our Pillars: Quality Assurance and Effective
                      Communication.
                    </h4>
                    <p className=" third-para">
                      We strive to provide extraordinary ideas that enhance your
                      business and nurture its success in the market. By merging
                      innovative concepts with practical solutions, we sow the
                      seeds of achievement and are dedicated to unlocking the
                      full potential of every company through our services.
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth Section */}
      <section className="bd-skill-area pb-10">
        <div className="bd-choose-shape">
          <div className="container" style={{ maxWidth: "1270px" }}>
            <div className="row">
              <div className="col-lg-6 fourth-about-section1">
                <div className="bd-section-title-wrapper mb-30">
                  <h3
                    className="bd-section-title mb-10"
                    style={{ fontSize: "46px" }}
                  >
                    Industries Covered
                  </h3>
                  <p>
                    With over 15 years of industry experience, we've amassed a
                    wealth of knowledge spanning diverse global sectors. Our
                    portfolio boasts successful partnerships with both small and
                    medium-sized enterprises, as well as major corporations. At
                    Zithas, we consistently strengthen our workforce, providing
                    a distinct advantage to any organization. Through our
                    innovative offerings, we've empowered businesses to maintain
                    a competitive edge in today's market.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 fourth-about-section2">
                <div className="container_new mb-30">
                  <div
                    className="pr-20 "
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip">
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/electric-bike_gwmeez.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/electric-bike_gwmeez.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/health-care_jejqsw.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441371/website/about-us/health-care_jejqsw.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/logistics_j73ggc.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/logistics_j73ggc.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                </div>
                <div className="container_new2">
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/security-tech_yavltg.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/security-tech_yavltg.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441373/website/about-us/travel-visa_yfhqui.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441373/website/about-us/travel-visa_yfhqui.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                  <div
                    className="pr-20"
                    style={{ color: "black", width: "33.33%" }}
                  >
                    <div className="box_flip" style={{}}>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/many-more_fjotr6.jpg"
                        height="127"
                        width="180"
                      ></img>
                      <img
                        src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/many-more_fjotr6.jpg"
                        height="127"
                        width="180"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section */}
      <section className="bd-about-area">
        <div className="bd-custom-container pt-80 pb-80">
          <div className="bd-about-four-bg pb-0 fix">
            <div className="bd-about-shape-box">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8 fifth-about-section1">
                    <div className="bd-about-img mb-30">
                      <div className="comments-box">
                        <div className="comments-avatar mt-80">
                          <img
                            src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659441372/website/about-us/julius-intro_api5ck.png"
                            className="img-fluid"
                            style={{ borderRadius: "50%", width: "500px" }}
                            alt="img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 pl-30 fifth-about-section2">
                    <div className="bd-about-text bd-about-text-four z-index">
                      <div className="bd-section-title-wrapper">
                        <h1 className="bd-slider-five-title wow fadeInUp fifth-about-tittle">
                          Excel by the Motto{" "}
                        </h1>
                        <h2
                          className="bd-slider-five-subtitle wow fadeInUp fifth-about-tittle"
                          style={{ fontSize: "30px" }}
                        >
                          We're Committed to Prioritizing Optimal Services for
                          Businesses
                        </h2>
                        <p className="mb-10 wow fadeInUp" data-wow-delay=".8s">
                          Our exclusive purpose revolves around ensuring client
                          satisfaction and actively bolstering the success of
                          their businesses. Anchored by the mantra 'You Grow, We
                          Grow,' we make it our top priority to align with our
                          clients' expectations and promote their growth and
                          prosperity.
                        </p>
                        <p className="mb-10 wow fadeInUp" data-wow-delay=".8s">
                          Zithas isn't just a business for us; it's a stage for
                          learning, growth, and accomplishment. This endeavor
                          serves as our motivation for achieving excellence and
                          ascending to the heights of success.
                        </p>
                        <p className=" wow fadeInUp" data-wow-delay=".8s">
                          At Zithas, our primary objective is comprehending and
                          meeting our clients' needs. We are dedicated to
                          crafting and implementing optimized strategies that
                          generate enhanced business opportunities for our
                          clients.
                        </p>
                        <p>
                          Our mission is centered around delivering
                          extraordinary ideas that empower your business to
                          flourish in the Canadian market. We accomplish this by
                          seamlessly merging creative concepts with practical
                          solutions, planting the seeds of success. We are
                          steadfast in our belief that our services bring out
                          the best in every company.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sixth section */}
      {/* <section className="bd-portfolio-area bd-portfolio-spacing  pb-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-12">
              <div className="bd-section-title-wrapper text-center mb-30">
                <h5 className="bd-section-subtitle mb-15 subtitle-without-border">
                  Visionary Team
                </h5>
                <h2 className="bd-section-title">Pillars of Zithas</h2>
                <p>
                  We're a team of professionals who maintain and lead the
                  company with their immense efforts and great ideas.
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-30">
            <div className="col-lg-4 col-md-6">
              <div className="bd-portfolio mb-30">
                <img src={Img1} alt="porfolio not found" />
                <div className="bd-portfolio-text">
                  <h5 className="bd-team-four-title">Julius Gohil</h5>
                  <span className="pb-15">Managing Director</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="bd-portfolio mb-30">
                <img src={Img2} alt="porfolio not found" />
                <div className="bd-portfolio-text">
                  <h5 className="bd-team-four-title">Yesha Makwana</h5>
                  <span className="pb-15">Chief Operations Officer</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="bd-portfolio mb-30">
                <img src={Img3} alt="porfolio not found" height='487' style={{objectFit:"cover"}} />
                <div className="bd-portfolio-text">
                  <h5 className="bd-team-four-title">Rejo Johnson</h5>
                  <span className="pb-15">Regional Marketing Manager</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bd-header-btn2 responsive-button">
            <Link to={"/pillars-of-zithas"}>
              {team.length > 3 ? (
                <button className="get-start">View All</button>
              ) : null}
            </Link>
          </div>
        </div>
      </section> */}

      <section className="bd-portfolio-area bd-portfolio-spacing  pb-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-12">
              <div className="bd-section-title-wrapper text-center mb-30">
                <h5 className="bd-section-subtitle mb-15 subtitle-without-border">
                  Visionary Team
                </h5>
                <h2 className="bd-section-title">Pillars of Zithas</h2>
                <p>
                  We're a team of professionals who maintain and lead the
                  company with their immense efforts and great ideas.
                </p>
              </div>
            </div>
          </div>
          {team.length ? (
            <div className="row mb-30">
              {team.slice(0, 6).map((img) => {
                const imgUrl = `${img.link?.includes("cloudinary") ? "" : "https://napi.zithas.com/"}${img.link}`;
                return (
                  <div className="col-lg-4 col-md-6" key={img.id}>
                    <div className="bd-portfolio mb-30">
                      <img src={imgUrl} alt="porfolio not found" />
                      <div className="bd-portfolio-text">
                        <h5 className="bd-team-four-title">{img.name}</h5>
                        <span className="pb-15">{img.designation}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="row mb-30">
              <div className="col-lg-4 col-md-6">
                <div className="bd-portfolio mb-30">
                  <img src={Img1} alt="porfolio not found" />
                  <div className="bd-portfolio-text">
                    <h5 className="bd-team-four-title">Julius Gohil</h5>
                    <span className="pb-15">Managing Director</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="bd-portfolio mb-30">
                  <img src={Img2} alt="porfolio not found" />
                  <div className="bd-portfolio-text">
                    <h5 className="bd-team-four-title">Yesha Makwana</h5>
                    <span className="pb-15">Chief Operations Officer</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="bd-portfolio mb-30">
                  <img
                    src={Img3}
                    alt="porfolio not found"
                    height="487"
                    style={{ objectFit: "cover" }}
                  />
                  <div className="bd-portfolio-text">
                    <h5 className="bd-team-four-title">Rejo Johnson</h5>
                    <span className="pb-15">Regional Marketing Manager</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="bd-header-btn2 responsive-button">
            <Link to={"/pillars-of-zithas"}>
              {team.length > 6 ? (
                <button className="get-start">View All</button>
              ) : null}
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  In Pursuit of Business Growth?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding Outcome, let's begin without delay!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (647) 446-9073"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (647) 446-9073
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaAboutUs;
